// components/integration/integration-test-panel-manager.component.jsx

import HcaptchaIntegrationPanel from './providers/hcaptcha/hcaptcha-integration-panel.component';
import MailgunIntegrationPanel from './providers/mailgun/mailgun-integration-panel.component';
import PostmarkIntegrationPanel from './providers/postmark/postmark-integration-panel.component';
import RecaptchaIntegrationPanel from './providers/recaptcha/recaptcha-integration-panel.component';
import SendgridIntegrationPanel from './providers/sendgrid/sendgrid-integration-panel.component';
import SesIntegrationPanel from './providers/ses/ses-integration-panel.component';

const IntegrationTestManager = ({ integration }) => {
  switch (integration?.service) {
    case 'hcaptcha':
      return <HcaptchaIntegrationPanel integration={integration} />;
    case 'mailgun':
      return <MailgunIntegrationPanel integration={integration} />;
    case 'postmark':
      return <PostmarkIntegrationPanel integration={integration} />;
    case 'recaptcha':
      return <RecaptchaIntegrationPanel integration={integration} />;
    case 'sendgrid':
      return <SendgridIntegrationPanel integration={integration} />;
    case 'ses':
      return <SesIntegrationPanel integration={integration} />;
    default:
      return null;
  }
};

export default IntegrationTestManager;